export default "__VITE_ASSET__C4HEYB_d__"